import React from "react";
import { Dropdown, getTheme, Label, mergeStyleSets, PrimaryButton, ResponsiveMode } from "@fluentui/react";
import SnippetsMenuButton from "./SnippetsMenuButton";
import { numberOfSnippets } from "../helpers/snippetHelpers";

const getClassNames = (theme) =>
  mergeStyleSets({
    root: { display: "flex", flexDirection: "column", flexGrow: 1 },
    topContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: theme.spacing.s1,
      margin: theme.spacing.s1,
    },
    button: {
      margin: "4px 0",
    },
    dropdown: {
      margin: "4px 0",
    },
    addNewBtn: {
      background: theme.palette.themePrimaryLight,
      border: `1px solid ${theme.palette.themePrimaryLight}`,
      color: theme.palette.white,
      paddingTop: theme.spacing.l1,
      paddingBottom: theme.spacing.l1,
    },
    divider: {
      border: 0,
      height: "1.25px",
      background: theme.palette.borderDark,
      margin: "1px 0",
    },
    snippetsContainer: {
      background: theme.palette.white,
      padding: theme.spacing.m,
      paddingTop: theme.spacing.s2,
      flexGrow: 1,
    },
    snippetsLabel: {
      fontSize: 13,
      marginTop: theme.spacing.m,
      color: theme.palette.themePrimary,
      borderBottom: `1.5px solid ${theme.palette.borderLight}`,
      paddingBottom: theme.spacing.s1,
      marginBottom: theme.spacing.s1,
    },
  });

const dropdownStyles = (theme) => {
  return { root: { label: { fontSize: "13px !important", color: `${theme.palette.themePrimary} !important` } } };
};

const SnippetsTab = ({
  snippets,
  caseAccountId,
  caseTypes,
  accountName,
  selectedCaseType,
  onCaseTypeChange,
  onInsertSnippetClick,
  onUpdateSnippet,
  onDeleteSnippet,
  onPreviewSnippet,
  onNewSnippetClick,
  hasAccountAccess,
  canManageGlobal,
}) => {
  let theme = getTheme();

  let { root, topContainer, dropdown, addNewBtn, divider, snippetsContainer, snippetsLabel } = getClassNames(theme);

  return (
    <div className={root}>
      <div className={topContainer}>
        <PrimaryButton className={addNewBtn} onClick={() => onNewSnippetClick()}>
          New Snippet
        </PrimaryButton>

        <Dropdown
          selectedKey={selectedCaseType ? selectedCaseType.key : 0}
          onChange={(e, type) => onCaseTypeChange(type)}
          label="Case Type"
          options={caseTypes}
          className={dropdown}
          styles={dropdownStyles(theme)}
          responsiveMode={ResponsiveMode.large}
        />
      </div>
      <hr className={divider} />
      <div className={snippetsContainer}>
        <Label className={snippetsLabel}>My Snippets ({numberOfSnippets(snippets?.advisor)})</Label>
        {snippets?.advisor?.map((snippet) => (
          <SnippetsMenuButton
            snippet={snippet}
            onInsert={onInsertSnippetClick}
            onDelete={onDeleteSnippet}
            onUpdate={onUpdateSnippet}
            onPreview={onPreviewSnippet}
            itemKey={snippet.key}
          />
        ))}
        {hasAccountAccess && (
          <>
            <Label className={snippetsLabel}>
              {accountName} Snippets ({numberOfSnippets(snippets?.account)})
            </Label>
            {snippets?.account?.map((snippet) => (
              <SnippetsMenuButton
                snippet={snippet}
                onInsert={onInsertSnippetClick}
                onDelete={onDeleteSnippet}
                onUpdate={onUpdateSnippet}
                onPreview={onPreviewSnippet}
                itemKey={snippet.key}
                caseAccountId={caseAccountId}
              />
            ))}
          </>
        )}

        <Label className={snippetsLabel}>Global Snippets ({numberOfSnippets(snippets?.global)})</Label>
        {snippets?.global?.map((snippet) => (
          <SnippetsMenuButton
            snippet={snippet}
            onInsert={onInsertSnippetClick}
            onDelete={onDeleteSnippet}
            onUpdate={onUpdateSnippet}
            onPreview={onPreviewSnippet}
            itemKey={snippet.key}
            isGlobal={true}
            canManageGlobal={canManageGlobal}
          />
        ))}
      </div>
    </div>
  );
};

export default SnippetsTab;
